//import { Subject } from 'rxjs/Subject';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpService {

  private baseURL = environment.apiUrl;

  constructor(private httpClient: HttpClient, private router: Router) { }

  removeCandidateEducationAlert(candidate_education_alert_id: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/delete-candidate-education-alert";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("candidate_education_alert_id", candidate_education_alert_id);

    return this.httpClient
      .post(url, formData);
  }

  addCandidateEducationAlert(form: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/candidate-education-alert";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("category", form.category);

    return this.httpClient
      .post(url, formData);
  }

  getEducations(category: any) {
    const url = ((category == null) || category == '') ? this.baseURL + "/education" : this.baseURL + "/education?category=" + category;

    let queryParams = new HttpParams();

    return this.httpClient
      .get<any[]>(url, { params: queryParams });
  }

  getEducationsCategories() {
    const url = this.baseURL + "/education-category";

    let queryParams = new HttpParams();

    return this.httpClient
      .get<any[]>(url, { params: queryParams });
  }

  generateRepport(job_id: any) {

    const url = this.baseURL + "/generate-report/" + job_id;

    var formData: any = new FormData();

    return this.httpClient
      .get(url, formData);
  }


  generateToExcel(type_user: any, data_selected: any, job_id: any) {

    const url = (job_id == null) ? this.baseURL + "/generate-file/" + type_user + "?data_selected=" + data_selected : this.baseURL + "/generate-file/" + type_user + "?data_selected=" + data_selected + "&job_id=" + job_id;

    var formData: any = new FormData();

    return this.httpClient
      .get(url, formData);
  }

  searchConsultant(form: { produits: string; expertises: string; country: string; daily_fee: string; nb_mission: string; }) {
    const url = this.baseURL + "/search-consultant";

    let queryParams = new HttpParams();
    queryParams = queryParams.append("produits", form.produits);
    queryParams = queryParams.append("expertises", form.expertises);
    queryParams = queryParams.append("country", form.country);
    queryParams = queryParams.append("daily_fee", form.daily_fee);
    queryParams = queryParams.append("nb_mission", form.nb_mission);

    return this.httpClient
      .get<any[]>(url, { params: queryParams });
  }

  removeConsultantCountry(consultant_country_id: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/delete-consultant-country";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("consultant_country_id", consultant_country_id);

    return this.httpClient
      .post(url, formData);
  }

  addConsultantCountry(form: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/consultant-country";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("country", form.country);

    return this.httpClient
      .post(url, formData);
  }

  removeConsultantMission(consultant_mission_id: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/delete-consultant-mission";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("consultant_mission_id", consultant_mission_id);

    return this.httpClient
      .post(url, formData);
  }

  addConsultantMission(form: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/consultant-mission";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("title", form.title);
    formData.append("description", form.description);
    formData.append("certificat", form.certificat);

    return this.httpClient
      .post(url, formData);
  }

  removeConsultantExpertise(consultant_expertise_id: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/delete-consultant-expertise";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("consultant_expertise_id", consultant_expertise_id);

    return this.httpClient
      .post(url, formData);
  }

  addConsultantExpertise(form: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/consultant-expertise";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("expertise_id", form.expertise_id);

    return this.httpClient
      .post(url, formData);
  }

  removeConsultantProduit(consultant_produit_id: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/delete-consultant-produit";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("consultant_produit_id", consultant_produit_id);

    return this.httpClient
      .post(url, formData);
  }

  addConsultantProduit(form: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/consultant-produit";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("produit_id", form.produit_id);

    return this.httpClient
      .post(url, formData);
  }

  getExpertises() {
    const url = this.baseURL + "/expertise";
    return this.httpClient
      .get<any[]>(url);
  }

  getProduits() {
    const url = this.baseURL + "/produit";
    return this.httpClient
      .get<any[]>(url);
  }

  editConsultant(form: any) {
    const url = this.baseURL + "/edit/consultant";

    var formData: any = new FormData();
    formData.append("gender", form.gender);
    formData.append("first_name", form.first_name);
    formData.append("last_name", form.last_name);
    formData.append("email", form.email);
    formData.append("date_birth", form.date_birth);
    formData.append("phone_1", form.phone_1);
    formData.append("phone_2", form.phone_2);
    formData.append("cv_file", form.cv_file);
    formData.append("daily_fee", form.daily_fee);

    return this.httpClient
      .post(url, formData);
  }

  registerConsultant(form: any) {
    const url = this.baseURL + "/consultant";

    var formData: any = new FormData();
    formData.append("gender", form.gender);
    formData.append("first_name", form.first_name);
    formData.append("last_name", form.last_name);
    formData.append("phone_1", form.phone_1);
    formData.append("email", form.email);
    formData.append("password", form.password);

    return this.httpClient
      .post(url, formData);
  }

  getAllAdmin() {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/admin-list";

    return this.httpClient
      .get(url);
  }

  lockUnlockAdmin(email: string, is_locked: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/lock-admin";

    var formData: any = new FormData();
    formData.append("email", email);
    formData.append("is_locked", is_locked);

    return this.httpClient
      .post(url, formData);
  }

  updateAdmin(form: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/edit-admin";

    var formData: any = new FormData();
    formData.append("name", form.name);
    formData.append("email", form.email);
    formData.append("password", form.password);
    formData.append("profile_id", form.profile_id);

    return this.httpClient
      .post(url, formData);
  }

  saveAdmin(form: { name: string; email: string; password: string; profile_id: any; }) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/admin";

    var formData: any = new FormData();
    formData.append("name", form.name);
    formData.append("email", form.email);
    formData.append("password", form.password);
    formData.append("profile_id", form.profile_id);

    return this.httpClient
      .post(url, formData);
  }

  subscribeNewsletter(form: { email: string }) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/newsletters";

    var formData: any = new FormData();
    formData.append("email", form.email);

    return this.httpClient
      .post(url, formData);
  }

  searchCandidatesJobApply(form: { job_id: string; eligibility_rate: string; level_of_study: string; years_of_experience: string; position_level: string; training: string; language_level: string; }) {
    const url = this.baseURL + "/search-candidate-job-apply/" + form.job_id;

    let queryParams = new HttpParams();
    queryParams = queryParams.append("eligibility_rate", form.eligibility_rate);
    queryParams = queryParams.append("level_of_study", form.level_of_study);
    queryParams = queryParams.append("years_of_experience", form.years_of_experience);
    queryParams = queryParams.append("position_level", form.position_level);
    queryParams = queryParams.append("training", form.training);
    queryParams = queryParams.append("language_level", form.language_level);

    return this.httpClient
      .get<any[]>(url, { params: queryParams });
  }

  searchCandidate(form: { profession: string; level_of_study: string; years_of_experience: string; position_level: string; training: string; language_level: string; }) {
    const url = this.baseURL + "/search-candidate";

    let queryParams = new HttpParams();
    queryParams = queryParams.append("profession", form.profession);
    queryParams = queryParams.append("level_of_study", form.level_of_study);
    queryParams = queryParams.append("years_of_experience", form.years_of_experience);
    queryParams = queryParams.append("position_level", form.position_level);
    queryParams = queryParams.append("training", form.training);
    queryParams = queryParams.append("language_level", form.language_level);

    return this.httpClient
      .get<any[]>(url, { params: queryParams });
  }

  searchJob(form: { country: string; level_of_study: string; years_of_experience: string; profession: string; status: string; }, page: any) {
    const url = this.baseURL + "/search-job";

    let queryParams = new HttpParams();
    queryParams = queryParams.append("country", form.country);
    queryParams = queryParams.append("level_of_study", form.level_of_study);
    queryParams = queryParams.append("years_of_experience", form.years_of_experience);
    queryParams = queryParams.append("profession", form.profession);
    queryParams = queryParams.append("status", form.status);
    queryParams = queryParams.append("page", page);

    return this.httpClient
      .get<any[]>(url, { params: queryParams });
  }

  getCandidatesJobApply(jobId: number) {
    const url = this.baseURL + "/candidate-job-apply/" + jobId;
    return this.httpClient
      .get<any[]>(url);
  }

  addSkill(libelle: string, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/skill";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("libelle", libelle);

    return this.httpClient
      .post(url, formData);
  }

  addLanguage(libelle: string, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/language";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("libelle", libelle);

    return this.httpClient
      .post(url, formData);
  }

  addTraining(libelle: string, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/training";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("libelle", libelle);

    return this.httpClient
      .post(url, formData);
  }

  addAreaActivity(libelle: string, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/area-activity";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("libelle", libelle);

    return this.httpClient
      .post(url, formData);
  }

  addProfession(libelle: string, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/profession";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("libelle", libelle);

    return this.httpClient
      .post(url, formData);
  }

  updateJobStatus(job_id: number, status: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/update-job-status";

    var formData: any = new FormData();
    formData.append("job_id", job_id);
    formData.append("status", status);

    return this.httpClient
      .post(url, formData);
  }

  removeJobSkill(job_skill_id: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/remove-job-skill";

    var formData: any = new FormData();
    formData.append("job_skill_id", job_skill_id);

    return this.httpClient
      .post(url, formData);
  }

  addJobSkill(form: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/job-skill";

    var formData: any = new FormData();
    formData.append("job_id", form.job_id);
    formData.append("skill_id", form.skill_id);
    formData.append("level", form.level);
    formData.append("rating", form.rating);

    return this.httpClient
      .post(url, formData);
  }

  removeJobLanguage(job_language_id: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/remove-job-language";

    var formData: any = new FormData();
    formData.append("job_language_id", job_language_id);

    return this.httpClient
      .post(url, formData);
  }

  addJobLanguage(form: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/job-language";

    var formData: any = new FormData();
    formData.append("job_id", form.job_id);
    formData.append("language_id", form.language_id);
    formData.append("level", form.level);
    formData.append("rating", form.rating);

    return this.httpClient
      .post(url, formData);
  }

  removeJobTraining(job_training_id: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/remove-job-training";

    var formData: any = new FormData();
    formData.append("job_training_id", job_training_id);

    return this.httpClient
      .post(url, formData);
  }

  addJobTraining(form: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/job-training";

    var formData: any = new FormData();
    formData.append("job_id", form.job_id);
    formData.append("training_id", form.training_id);
    formData.append("level_of_study", form.level_of_study);
    formData.append("rating", form.rating);
    formData.append("certifcat_rating", form.certifcat_rating);

    return this.httpClient
      .post(url, formData);
  }

  deleteJob(form: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': form.token
      })
    };
    const url = this.baseURL + "/delete-job";

    var formData: any = new FormData();
    formData.append("token", form.token);
    formData.append("job_id", form.job_id);

    return this.httpClient
      .post(url, formData);
  }

  updateJob(form: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': form.token
      })
    };
    const url = this.baseURL + "/update-job";

    var formData: any = new FormData();
    formData.append("token", form.token);
    formData.append("job_id", form.job_id);
    formData.append("profession_id", form.profession_id);
    formData.append("company_id", form.company_id);
    formData.append("area_activity_id", form.area_activity_id);
    formData.append("libelle", form.libelle);
    formData.append("description", form.description);
    formData.append("type_job", form.type_job);
    formData.append("job_level", form.job_level);
    formData.append("country", form.country);
    formData.append("city", form.city);
    formData.append("max_age", form.max_age);
    formData.append("min_age", form.min_age);
    formData.append("age_rating", form.age_rating);
    formData.append("years_of_experience", form.years_of_experience);
    formData.append("years_exp_rating", form.years_exp_rating);
    formData.append("expiration_date", form.expiration_date);
    formData.append("job_describe", form.job_describe);

    return this.httpClient
      .post(url, formData);
  }

  saveJob(form: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };
    const url = this.baseURL + "/create-job";

    var formData: any = new FormData();
    formData.append("profession_id", form.profession_id);
    formData.append("company_id", form.company_id);
    formData.append("area_activity_id", form.area_activity_id);
    formData.append("libelle", form.libelle);
    formData.append("description", form.description);
    formData.append("type_job", form.type_job);
    formData.append("job_level", form.job_level);
    formData.append("country", form.country);
    formData.append("city", form.city);
    formData.append("max_age", form.max_age);
    formData.append("min_age", form.min_age);
    formData.append("age_rating", form.age_rating);
    formData.append("years_of_experience", form.years_of_experience);
    formData.append("years_exp_rating", form.years_exp_rating);
    formData.append("expiration_date", form.expiration_date);
    formData.append("job_describe", form.job_describe);

    return this.httpClient
      .post(url, formData);
  }

  loginAdmin(loginForm: { email: string; password: string }) {
    const url = this.baseURL + "/sign-in/admin";

    var formData: any = new FormData();
    formData.append("email", loginForm.email);
    formData.append("password", loginForm.password);

    return this.httpClient
      .post(url, formData);
  }

  applyJob(form: any) {

    const url = this.baseURL + "/apply-job";
    var formData: any = new FormData();
    formData.append("token", form.token);
    formData.append("job_id", form.job_id);
    formData.append("availability", form.availability);
    formData.append("mobility", form.mobility);
    formData.append("status", form.status);
    formData.append("current_salary", form.current_salary);
    formData.append("desired_salary", form.desired_salary);
    formData.append("curriculum_vitae", form.curriculum_vitae);
    formData.append("cover_letter", form.cover_letter);
    formData.append("certificat", form.certificat);
    formData.append("experience", form.experience);
    formData.append("training", form.training);


    console.log(formData['job_id']);

    // form['token'] = token;

    return this.httpClient
      .post(url, formData);
  }

  removeBackupJob(job_id: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/delete-backup-job";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("job_id", job_id);

    return this.httpClient
      .post(url, formData);
  }

  saveBackupJob(job_id: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/backup-job";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("job_id", job_id);

    return this.httpClient
      .post(url, formData);
  }

  removeCandidateJobAlert(candidate_job_alert_id: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/delete-candidate-job-alert";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("candidate_job_alert_id", candidate_job_alert_id);

    return this.httpClient
      .post(url, formData);
  }

  addCandidateJobAlert(form: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/candidate-job-alert";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("level_of_study", form.level_of_study);
    formData.append("training_id", form.training_id);
    formData.append("years_of_experience", form.years_of_experience);
    formData.append("profession_id", form.profession_id);

    return this.httpClient
      .post(url, formData);
  }

  removeCandidateCertificat(candidate_certificat_id: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/delete-candidate-certificat";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("candidate_certificat_id", candidate_certificat_id);

    return this.httpClient
      .post(url, formData);
  }

  addCandidateCertificat(form: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/candidate-certificat";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("libelle", form.libelle);
    formData.append("certificat", form.certificat);

    return this.httpClient
      .post(url, formData);
  }

  removeCandidateSkill(candidate_skill_id: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/delete-candidate-skill";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("candidate_skill_id", candidate_skill_id);

    return this.httpClient
      .post(url, formData);
  }

  addCandidateSkill(form: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/candidate-skill";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("level", form.level);
    formData.append("skill_id", form.skill_id);

    return this.httpClient
      .post(url, formData);
  }

  removeCandidateLanguage(candidate_language_id: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/delete-candidate-language";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("candidate_language_id", candidate_language_id);

    return this.httpClient
      .post(url, formData);
  }

  addCandidateLanguage(form: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/candidate-language";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("level", form.level);
    formData.append("language_id", form.language_id);
    formData.append("certificat", form.certificat);

    return this.httpClient
      .post(url, formData);
  }

  getCandidates() {
    const url = this.baseURL + "/candidate";
    return this.httpClient
      .get<any[]>(url);
  }

  getCompanies() {
    const url = this.baseURL + "/company";
    return this.httpClient
      .get<any[]>(url);
  }

  getSkills() {
    const url = this.baseURL + "/skill";
    return this.httpClient
      .get<any[]>(url);
  }

  getLanguages() {
    const url = this.baseURL + "/language";
    return this.httpClient
      .get<any[]>(url);
  }

  removeCandidateTraining(candidate_training_id: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/delete-candidate-training";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("candidate_training_id", candidate_training_id);

    return this.httpClient
      .post(url, formData);
  }

  addCandidateTraining(form: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/candidate-training";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("level_of_study", form.level_of_study);
    formData.append("training_id", form.training_id);
    formData.append("university", form.university);
    formData.append("period_start", form.period_start);
    formData.append("period_end", form.period_end);
    formData.append("in_progress", form.in_progress);
    formData.append("diploma", form.diploma);

    return this.httpClient
      .post(url, formData);
  }
  editCandidateTraining(form: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/candidate-training-edit";
    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("candidate_training_id", form.candidate_training_id);
    formData.append("level_of_study", form.level_of_study);
    formData.append("training_id", form.training_id);
    formData.append("university", form.university);
    formData.append("period_start", form.period_start);
    formData.append("period_end", form.period_end);
    formData.append("in_progress", form.in_progress);
    formData.append("diploma", form.diploma);

    return this.httpClient
      .post(url, formData);
  }
  removeCandidateExperience(candidate_experience_id: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/delete-candidate-experience";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("candidate_experience_id", candidate_experience_id);

    return this.httpClient
      .post(url, formData);
  }

  addCandidateExperience(form: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/candidate-experience";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("area_activity_id", form.area_activity_id);
    formData.append("company", form.company);
    formData.append("profession_id", form.profession_id);
    formData.append("position_level", form.position_level);
    formData.append("period_start", form.period_start);
    formData.append("period_end", form.period_end);
    formData.append("in_progress", form.in_progress);
    formData.append("team_management", form.team_management);
    formData.append("certificate", form.certificate);
    formData.append("job_title", form.job_title);
    formData.append("supervisor_title", form.supervisor_title);
    formData.append("reason_for_leaving", form.reason_for_leaving);
    formData.append("task_description", form.task_description);
    formData.append("realisation", form.realisation);
    formData.append("work_description", form.work_description);

    return this.httpClient
      .post(url, formData);
  }
  updateCandidateExperience(form: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token
      })
    };
    const url = this.baseURL + "/update-candidate-experience";

    var formData: any = new FormData();
    formData.append("candidate_experience_id", form.candidate_experience_id);
    formData.append("token", token);
    formData.append("area_activity_id", form.area_activity_id);
    formData.append("company", form.company);
    formData.append("position_level", form.position_level);
    formData.append("period_start", form.period_start);
    formData.append("period_end", form.period_end);
    formData.append("in_progress", form.in_progress);
    formData.append("team_management", form.team_management);
    formData.append("certificate", form.certificate);
    formData.append("job_title", form.job_title);
    formData.append("supervisor_title", form.supervisor_title);
    formData.append("reason_for_leaving", form.reason_for_leaving);
    formData.append("task_description", form.task_description);
    formData.append("work_description", form.work_description);

    return this.httpClient
      .post(url, formData);
  }

  updateProfile(form: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer my-token'
      })
    };
    const url = this.baseURL + "/candidate-profile";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("profession_id", form.profession_id);

    return this.httpClient
      .post(url, formData);
  }

  getAreaActivities() {
    const url = this.baseURL + "/area-activity";
    return this.httpClient
      .get<any[]>(url);
  }

  getTrainings() {
    const url = this.baseURL + "/training";
    return this.httpClient
      .get<any[]>(url);
  }

  getProfessions() {
    const url = this.baseURL + "/profession";
    return this.httpClient
      .get<any[]>(url);
  }

  getCountries() {
    return this.httpClient.get("assets/countriesData.json")
  }

  editCompany(form: { name: any; acronym: any; area_activity_id: any; email: any; description: any; phone_1: any; phone_2: any; city: any; country: any; address: any; nb_person: any; website_link: any; name_creator: any; position_creator: any; logo: any; }) {
    const url = this.baseURL + "/update-company";

    var formData: any = new FormData();
    formData.append("name", form.name);
    formData.append("acronym", form.acronym);
    formData.append("area_activity_id", form.area_activity_id);
    formData.append("email", form.email);
    formData.append("description", form.description);
    formData.append("phone_1", form.phone_1);
    formData.append("phone_2", form.phone_2);
    formData.append("city", form.city);
    formData.append("country", form.country);
    formData.append("address", form.address);
    formData.append("nb_person", form.nb_person);
    formData.append("website_link", form.website_link);
    formData.append("name_creator", form.name_creator);
    formData.append("position_creator", form.position_creator);
    formData.append("logo", form.logo);

    return this.httpClient
      .post(url, formData);
  }

  adminRegisterCompany(form: { name: any, acronym: any, area_activity_id: any, city: any, country: any, address: any, logo: any }) {

    const url = this.baseURL + "/adminRegistercompany";

    var formData: any = new FormData();

    formData.append("name", form.name);
    formData.append("acronym", form.acronym);
    formData.append("area_activity_id", form.area_activity_id);
    formData.append("city", form.city);
    formData.append("country", form.country);
    formData.append("address", form.address);
    formData.append("logo", form.logo);

    return this.httpClient
      .post(url, formData);
  }




  registerCompany(form: { name: any; acronym: any; area_activity_id: any; email: any; phone_1: any; city: any; country: any; address: any; nb_person: any; password: any; }) {
    const url = this.baseURL + "/company";

    var formData: any = new FormData();
    formData.append("name", form.name);
    formData.append("acronym", form.acronym);
    formData.append("area_activity_id", form.area_activity_id);
    formData.append("email", form.email);
    formData.append("phone_1", form.phone_1);
    formData.append("city", form.city);
    formData.append("country", form.country);
    formData.append("address", form.address);
    formData.append("nb_person", form.nb_person);
    formData.append("password", form.password);

    return this.httpClient
      .post(url, formData);
  }
  createProfile(form: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer my-token'
      })
    };
    const url = this.baseURL + "/candidate-profile";

    var formData: any = new FormData();
    formData.append("token", token);
    formData.append("profession_id", form.profession_id);

    return this.httpClient
      .post(url, formData);
  }
  editCandidateData(form: any) {
    const url = this.baseURL + "/edit/candidate";

    var formData: any = new FormData();
    formData.append("gender", form.gender);
    formData.append("first_name", form.firstName);
    formData.append("last_name", form.lastName);
    formData.append("email", form.email);
    formData.append("date_birth", form.dateBirth);
    formData.append("profil", form.profil);
    formData.append("phone1", form.phone1);
    formData.append("phone2", form.phone2);
    formData.append("cvFile", form.cvFile);
    formData.append("idcard", form.idcard);
    formData.append("country", form.country);
    formData.append("city", form.city);
    formData.append("maritalStatus", form.maritalStatus);
    formData.append("photoFile", form.photoFile);
    // formData.append("tempWorker", form.tempWorker);
    // formData.append("driverLicence", form.driverLicence);
    // formData.append("passport", form.passport);

    return this.httpClient
      .post(url, formData);
  }

  changePassword(form: { token: string; oldPassword: string; newPassword: string; confirmPassword: string; type_user: string }) {

    const url = this.baseURL + "/change-password/" + form.type_user + "?token=" + form.token;

    var formData: any = new FormData();
    formData.append("oldPassword", form.oldPassword);
    formData.append("newPassword", form.newPassword);
    formData.append("confirmPassword", form.confirmPassword);

    return this.httpClient
      .post(url, formData);
  }

  createPassword(form: { token: string; newPassword: string; confirmPassword: string; type_user: string; }) {

    const url = this.baseURL + "/create-password/" + form.type_user + "?token=" + form.token;

    const redirectURL = window.location.origin + '/connexion';

    var formData: any = new FormData();
    formData.append("newPassword", form.newPassword);
    formData.append("confirmPassword", form.confirmPassword);
    formData.append("redirectURL", redirectURL);

    return this.httpClient
      .post(url, formData);
  }

  resetPassword(loginForm: any) {
    const url = this.baseURL + "/reset-password/" + loginForm.type_user;
    const redirectURL = window.location.origin + '/creer-mot-de-passe/' + loginForm.type_user;

    var formData: any = new FormData();
    formData.append("email", loginForm.email);
    formData.append("redirectURL", redirectURL);

    return this.httpClient
      .post(url, formData);
  }

  registerCandidate(form: any) {
    const url = this.baseURL + "/candidate";

    var formData: any = new FormData();
    formData.append("gender", form.gender);
    formData.append("first_name", form.firstName);
    formData.append("last_name", form.lastName);
    formData.append("marital_status", form.marital_status);
    formData.append("country", form.country);
    formData.append("city", form.city);
    formData.append("phone1", form.phone1);
    formData.append("email", form.email);
    formData.append("password", form.password);
    formData.append("profil", form.profil);
    return this.httpClient
      .post(url, formData);
  }

  login(typeUser: string, loginForm: { email: string; password: string }) {

    const url = this.baseURL + "/sign-in/" + typeUser;

    var formData: any = new FormData();
    formData.append("email", loginForm.email);
    formData.append("password", loginForm.password);

    return this.httpClient
      .post(url, formData);
  }

  contact(form: { name: any; email: any; subject: any; message: any; filiale: any; }) {

    const url = this.baseURL + "/contact";

    var formData: any = new FormData();
    formData.append("name", form.name);
    formData.append("email", form.email);
    formData.append("subject", form.subject);
    formData.append("message", form.message);
    formData.append("filiale", form.filiale);

    return this.httpClient
      .post(url, formData);
  }

  getJobById(jobId: number) {
    const url = this.baseURL + "/job/" + jobId;
    return this.httpClient
      .get<any[]>(url);
  }

  getJobs(status: string, page: any, max_record_per_page: any) {
    const url = this.baseURL + "/job";

    let queryParams = new HttpParams();
    queryParams = queryParams.append("status", status);
    queryParams = queryParams.append("page", page);
    queryParams = queryParams.append("max_record_per_page", max_record_per_page);

    return this.httpClient
      .get<any[]>(url, { params: queryParams });
  }
}